import './App.css';
import HomeScreen from './screens/HomeScreen';
import { AuthProvider } from './contexts/AuthContext';
import { LanguageProvider } from './contexts/LanguageContext';

function App() {
  return (
    <AuthProvider>
      <LanguageProvider>
        <div className="App">
          <HomeScreen />
        </div>
      </LanguageProvider>
    </AuthProvider>
  );
}

export default App;
